import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SessionService } from '../session/session.service';

class SpringAuthority {
    authority: string;
}

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {
    constructor(public sessionService: SessionService) {
    }

    hasAccess(permissions: Array<string>): Observable<boolean> {
        return new Observable((obs) => {
            this.sessionService.getUser().subscribe((user) => {
                const entitlements = permissions ? permissions.reduce((map, key) => {
                    map[this.removeCase(key)] = true;
                    return map;
                }, {}) : [];

                // TODO: only supporting or for now.
                // const op: 'and' | 'or' = route.data ? route.data.op : 'or';

                obs.next(user && user.authorities ? user.authorities.filter(
                    authority => entitlements[this.removeCase(authority)]).length > 0 : false);
                obs.complete();
            });
        });
    }

    removeCase(val) {
        if (typeof val === 'string') {
            return val.toUpperCase();
        } else if ((<SpringAuthority>val).authority !== undefined) {
            return this.removeCase(val.authority);
        }
        return undefined;
    }
}
